import BreadCrumb from "../../components/Breadcrumb";
import PendingPractitioners from "./PendingPractitioners";
import PractitionersList from "./PractitionersList";
const Practitioners = () => {
  return (
    <div className="patients-page">
      <BreadCrumb pageName="Practitioners" />
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">Practitioners</h3>
          <p className="page-desc">
            View or add practitioners to share your profile with and allow them
            to make prescriptions for you. Activate or deactivate as you see
            fit.
          </p>
          <div className="m-1">
            <PendingPractitioners />
            <PractitionersList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Practitioners;
